// import React, { useState, useEffect, useRef } from "react";
// import { Container} from "@mui/material";
// import Grid from "@mui/material/Grid2";
// import Wave from "../../icon/wave.webp";
// import "./OurJourney.scss";

// const NumberCounter = ({ end, run }) => {
//   const [count, setCount] = useState(0);

//   useEffect(() => {
//     if (!run) {
//       setCount(0);
//       return;
//     }

//     let start = 0;
//     const duration = 2000; // 2 seconds
//     const increment = end / (duration / 16);

//     const counter = setInterval(() => {
//       start += increment;
//       if (start >= end) {
//         start = end;
//         clearInterval(counter);
//       }
//       setCount(Math.floor(start));
//     }, 16);

//     return () => clearInterval(counter);
//   }, [run, end]);

//   return <>{count}</>;
// };

// const OurJourney = () => {
//   const [inView, setInView] = useState(false);
//   const sectionRef = useRef(null);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setInView(true);
//         }
//       },
//       { threshold: 0.5 } // 50% dikh jaye toh chalu ho
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => {
//       if (sectionRef.current) {
//         observer.unobserve(sectionRef.current);
//       }
//     };
//   }, []);

//   return (
//     <div className="our-journey" ref={sectionRef}>
//        <img  loading="lazy" src={Wave} alt="" className="wave" />
//       <Container className="container" >
//         <h4>Our Journey so Far</h4>
//         <Grid
//   container
//   justifyContent="center"
//   alignItems="center"
//   spacing={8} // add spacing between items
// >
//   <Grid item xs={6} sm={6} md={3}>
//     <h5><NumberCounter end={100} run={inView} />+</h5>
//     <span>Team Members</span>
//   </Grid>
//   <Grid item xs={6} sm={6} md={3}>
//     <h5><NumberCounter end={50} run={inView} />+</h5>
//     <span style={{ whiteSpace: "nowrap" }}>Salesforce Solutions</span>
//   </Grid>
//   <Grid item xs={6} sm={6} md={3}>
//     <h5><NumberCounter end={10} run={inView} />+</h5>
//     <span style={{ whiteSpace: "nowrap" }}>Industry Verticals</span>
//   </Grid>
//   <Grid item xs={6} sm={6} md={3}>
//     <h5><NumberCounter end={240} run={inView} />+</h5>
//     <span>Certifications</span>
//   </Grid>
// </Grid>

//       </Container>
//     </div>
//   );
// };

// export default OurJourney;

import React, { useState, useEffect, useRef } from "react";
import { Container } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Wave from "../../icon/wave.webp";
import "./OurJourney.scss";

const NumberCounter = ({ end, run }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!run) {
      setCount(0);
      return;
    }

    let start = 0;
    const duration = 2000; // 2 seconds
    const increment = end / (duration / 16);

    const counter = setInterval(() => {
      start += increment;
      if (start >= end) {
        start = end;
        clearInterval(counter);
      }
      setCount(Math.floor(start));
    }, 16);

    return () => clearInterval(counter);
  }, [run, end]);

  return <>{count}</>;
};

const OurJourney = () => {
  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        }
      },
      { threshold: 0.5 },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div className="our-journeys" ref={sectionRef}>
      <Container>
        <Grid className="container">
          <h4>Our Journey so Far</h4>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={8}
          >
            <Grid item xs={6} sm={6} md={3}>
              <h5>
                <span className="counter">
                  <NumberCounter end={100} run={inView} />+
                </span>
              </h5>
              <span className="our_jou_span">
                <p>Team Members</p>
              </span>
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <h5>
                <span className="counter">
                  <NumberCounter end={100} run={inView} />+
                </span>
              </h5>
              <span className="our_jou_span" style={{ whiteSpace: "nowrap" }}>
                {" "}
                <p>Salesforce Implementation</p>{" "}
              </span>
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <h5>
                <span className="counter">
                  <NumberCounter end={12} run={inView} />+
                </span>
              </h5>
              <span className="our_jou_span" style={{ whiteSpace: "nowrap" }}>
                {" "}
                <p>Industry Verticals</p>{" "}
              </span>
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <h5>
                <span className="counter">
                  <NumberCounter end={100} run={inView} />%
                </span>
              </h5>
              <span className="our_jou_span">
                {" "}
                <p>Salesforce Certified</p>{" "}
              </span>
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <h5>
                <span className="counter">
                  <NumberCounter end={80} run={inView} />+
                </span>
              </h5>
              <span className="our_jou_span">
                {" "}
                <p>Happy Customers</p>{" "}
              </span>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default OurJourney;
